module.exports = __webpack_public_path__ + "img/tour-37.a1955e29.png";